"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSVExport = void 0;
var CSVExport = /** @class */ (function () {
    function CSVExport() {
    }
    CSVExport.prototype.aoaToCsv = function (body) {
        var csvContent = '';
        body.forEach(function (row) {
            csvContent += row.join(';') + ';\n';
        });
        return csvContent;
    };
    return CSVExport;
}());
exports.CSVExport = CSVExport;
